import api from "@/services/api-config/rxjs-config";
import axios from "axios";
import { Observable } from "rxjs";

export class AddressRest {
  getAddressByCEP(cep: string): Observable<any> {
    const url: string = `https://viacep.com.br/ws/${cep}/json/`;
    return api.get(url);
  }
}
